// Service for hotel restaurant API calls (Exigences 4.4, 6.3)
import { API_BASE_URL } from '../config/apiConfig';
import { HotelRestaurant } from '../types/restaurant';

function getAuthHeaders(): HeadersInit {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
  };
}

export const restaurantService = {
  async list(hotelId?: string): Promise<HotelRestaurant[]> {
    const response = await fetch(`${API_BASE_URL}/hotel/restaurants`, {
      headers: getAuthHeaders(),
    });
    if (!response.ok) throw new Error('Erreur lors du chargement des restaurants');
    const data = await response.json();
    return data.restaurants || (Array.isArray(data) ? data : []);
  },

  async getById(hotelId: string, restaurantId: string): Promise<HotelRestaurant> {
    const response = await fetch(`${API_BASE_URL}/hotel/restaurants/${restaurantId}`, {
      headers: getAuthHeaders(),
    });
    if (!response.ok) throw new Error('Restaurant introuvable');
    return response.json();
  },

  async create(hotelId: string, data: HotelRestaurant): Promise<HotelRestaurant> {
    const response = await fetch(`${API_BASE_URL}/hotel/restaurants`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.error || 'Erreur lors de la création du restaurant');
    }
    const result = await response.json();
    return result.restaurant || result;
  },

  async update(hotelId: string, restaurantId: string, data: HotelRestaurant): Promise<HotelRestaurant> {
    const response = await fetch(`${API_BASE_URL}/hotel/restaurants/${restaurantId}`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.error || 'Erreur lors de la mise à jour du restaurant');
    }
    const result = await response.json();
    return result.restaurant || result;
  },

  async remove(hotelId: string, restaurantId: string): Promise<void> {
    const response = await fetch(`${API_BASE_URL}/hotel/restaurants/${restaurantId}`, {
      method: 'DELETE',
      headers: getAuthHeaders(),
    });
    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.error || 'Erreur lors de la suppression du restaurant');
    }
  },
};
